import { makeStyles, mergeClasses } from '@fluentui/react-components';
import type {
  GroundingCommandBarActionsSlots,
  GroundingCommandBarActionsState,
} from './GroundingCommandBarActions.types';
import type { SlotClassNames } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';

export const groundingCommandBarActionsClassNames: SlotClassNames<GroundingCommandBarActionsSlots> = {
  root: 'fai-GroundingCommandBarActions',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    gridArea: 'actions',
    display: 'flex',
    flexDirection: 'row',
    gap: tokens.spacingHorizontalXS,
  },
});

/**
 * Apply styling to the GroundingCommandBarActions slots based on the state
 */
export const useGroundingCommandBarActionsStyles_unstable = (
  state: GroundingCommandBarActionsState,
): GroundingCommandBarActionsState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(groundingCommandBarActionsClassNames.root, styles.root, state.root.className);

  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);

  return state;
};
